import { useLocation } from '@reach/router'
import queryString from 'query-string'

export const useLocationSearchParams = () => {
  const location = useLocation()
  return queryString.parse(location.search, { arrayFormat: 'index' })
}
